var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui container"},[_c('h1',{staticClass:"ui center aligned header"},[_vm._v("plab")]),_vm._v(" "),_c('description'),_vm._v(" "),_c('div',{staticClass:"ui divider"}),_vm._v(" "),_c('post')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbd542c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wall.vue
// module id = null
// module chunks = 